import { Browser } from "../../core/browser";
import { AuxiliumComponent } from "../auxilium-component";

export class BreadcrumbItem extends AuxiliumComponent {
	constructor() {
		super();

		this.link = this.getAttribute("link") ?? "";
		this.target = this.getAttribute("target");
		this.icon = this.getAttribute("icon") ?? "";

		if (Browser.ResolveRelativeURL(this.link) === location.toString()) { this.link = ""; }
	}

	parsedCallback() {
		this.appendChild(document.createElementWithContents("span", this.childNodes));

		if (this.link) {
			const anchor = document.createElementWithContents("a", this.childNodes, { href: Browser.ResolveRelativeURL(this.link) });

			if (this.target) { anchor.target = this.target; }
			if (this.target === "_blank") { anchor.appendChild(document.createElementWithContents("span", "(opens in new window)", { className: "visually-hidden" })) }

			this.appendChild(anchor);
		}

		if (this.icon) { (this.link ? this.querySelector("a") : this).prepend(document.createElementWithContents("chip-icon", null, { icon: this.icon })); }
	}
}